import { render, staticRenderFns } from "./CountryWithFlag.vue?vue&type=template&id=34006dd2&scoped=true"
import script from "./CountryWithFlag.vue?vue&type=script&lang=js"
export * from "./CountryWithFlag.vue?vue&type=script&lang=js"
import style0 from "./CountryWithFlag.vue?vue&type=style&index=0&id=34006dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34006dd2",
  null
  
)

export default component.exports